import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import * as moment from "moment";

import { Router } from "@angular/router";
import { UserModel } from "src/app/models/user.model";
import { AuthService } from "src/app/common/auth.service";
import { PaymentService } from "src/app/payment/payment.service";
import { PaymentCreateComponent } from "src/app/payment/payment.create.component";
import { NotificationService } from "src/app/common/notification.service";
import { UserService } from "../user.service";

@Component({
  selector: "app-add-card",
  templateUrl: "./add.card.component.html",
  styleUrls: ["./add.card.component.scss"],
})
//"./event.tickets.component.scss"
export class AddCardComponent implements OnInit {
  @ViewChild("paymentCreate", { static: false })
  paymentCreate: PaymentCreateComponent;
  @Output() onClose: EventEmitter<void> = new EventEmitter();
  currentUser: UserModel;
  cards: any[];
  purchaseInProgress = false;
  eventId: string;
  selectedCard: string;

  constructor(
    private router: Router,
    private authService: AuthService,
    private paymentService: PaymentService,
    private route: ActivatedRoute,
    private userService: UserService,
    private toasterService: NotificationService
  ) {}

  async ngOnInit() {
    this.currentUser = this.authService.getCurrentUser();
    this.eventId = this.route.snapshot.queryParams["eventId"];
    if (!this.currentUser) {
      this.redirectToBack();
    }
  }
  async addCardToAccount() {
    console.log(`Adding card`);
    this.purchaseInProgress = true;
    const stripeSource = await this.paymentCreate.getPaymentSource();
    if (!stripeSource) {
      this.purchaseInProgress = false;
      return null;
    }
    try {
      await this.userService.addNewCreditCard(this.currentUser.id, stripeSource);
      this.selectedCard = stripeSource.id;
      this.redirectToBack()
      this.toasterService.success('', 'Card successfully added')
    } catch (error) {
      this.toasterService.error('error', error.message)
    } finally {
      this.purchaseInProgress = false
    }
  }

  async resetAndLogout() {
    await this.authService.logout();
    this.currentUser = null;
    this.cards = [];
  }

  redirectToBack() {
    const url = this.eventId ? `/bookings/${this.eventId}` : `/events`
    return this.router.navigateByUrl(url);
  }
}
